import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { HardHat } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Missing reset token");
    setLoading(true);
    try {
      await api.post("/auth/reset", { token, password });
      toast.success("Password updated — please sign in");
      nav("/login");
    } catch (e) { toast.error(formatError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 rounded-xl p-8 shadow-xl shadow-slate-900/5" data-testid="reset-form">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-md bg-blue-600 flex items-center justify-center"><HardHat className="w-5 h-5 text-white" /></div>
          <div className="font-display font-extrabold uppercase tracking-widest">Quick Quotes</div>
        </Link>
        <h1 className="font-display text-2xl font-extrabold">Set a new password</h1>
        <div className="mt-6 space-y-4">
          <div>
            <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">New password</Label>
            <Input type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white" data-testid="reset-submit">
            {loading ? "Updating…" : "Update password"}
          </Button>
        </div>
      </form>
    </div>
  );
}
